import { getStoreLocalMoment } from './getStoreLocalMoment';

export const getOpensAtText = ({
  time,
  utcOffset,
  label,
}: {
  time: string | undefined;
  utcOffset: number | undefined;
  label: string;
}) => {
  const storeMoment = getStoreLocalMoment(time, utcOffset);

  if (!storeMoment) {
    return undefined;
  }

  return `${label} ${storeMoment.format('LT')}`;
};

export const getScheduleFromText = ({
  time,
  utcOffset,
  isOpeningBetweenNowAndClosing,
  prefix,
  todaySuffix,
}: {
  time: string | undefined;
  utcOffset: number | undefined;
  isOpeningBetweenNowAndClosing: boolean;
  prefix: string;
  todaySuffix: string;
}) => {
  const storeMoment = getStoreLocalMoment(time, utcOffset);

  if (!storeMoment) {
    return undefined;
  }

  const formatted = storeMoment.format(
    isOpeningBetweenNowAndClosing ? 'LT' : 'LT dddd',
  );
  const suffix = isOpeningBetweenNowAndClosing ? todaySuffix : '';

  return `${prefix} ${formatted} ${suffix}`;
};
